export default __webpack_public_path__ + "static/footer-logo-new-1-4f0cc230d8e5d3fedbdce55ff91b6ba9.svg";